<template>
  <v-card>
    <GenericListTableV2
      :parentID="this.parentID"
      :title="`Project Groups`"
      :headers="[
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'groupname' },
        { text: 'Description', value: 'description', editable: true},
        { text: 'Icon', value: 'button.icon', editable: true, type: 'icon' },
        { text: 'Icon Colour', value: 'button.class', editable: true, type: 'colour' }
      ]"
      :url="`/schemas/projectgroups`"
      :apiResponseField="`projectgroups`"
      :onClickRoute="`ProjectGroupSingle`"
      :onClickParams="getOnClickParams">
    </GenericListTableV2>
  </v-card>
</template>

<script>
import GenericListTableV2 from '@/components/Common/GenericListTableV2'
export default {
  name: 'ProjectGroupListTable',
  components: { GenericListTableV2 },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        id: item.id
      }
    }
  }
}
</script>
